import React from 'react';
import './ResourceSidebar.css';

const ResourceSidebar = ({ currentView, onViewChange, counts }) => {
  const menuItems = [
    {
      id: 'dashboard',
      icon: '📊',
      label: 'Dashboard',
      description: 'Main overview'
    },
    {
      id: 'deviations',
      icon: '🚨',
      label: 'Deviations',
      description: 'Count & allocation issues',
      count: counts?.deviations || 0,
      urgent: true
    },
    {
      id: 'expiring',
      icon: '⚠️',
      label: 'Expiring Allocations',
      description: 'Resources ending soon',
      count: counts?.expiring || 0,
      urgent: true
    },
    {
      id: 'projections',
      icon: '📈',
      label: 'Monthly Projections',
      description: 'Future planning',
      count: counts?.projections || 0
    },
    {
      id: 'bench',
      icon: '🏁',
      label: 'Bench Resources',
      description: 'Available resources',
      count: counts?.bench || 0
    }
  ];

  return (
    <div className="resource-sidebar">
      <div className="resource-sidebar-header">
        <h2>📊 Dashboard</h2>
        <p>Resource Management</p>
      </div>
      
      <nav className="resource-sidebar-nav">
        {menuItems.map(item => (
          <button
            key={item.id}
            className={`resource-nav-item ${currentView === item.id ? 'active' : ''} ${item.urgent ? 'urgent' : ''}`}
            onClick={() => onViewChange(item.id)}
          >
            <div className="resource-nav-item-content">
              <div className="resource-nav-item-main">
                <span className="resource-nav-icon">{item.icon}</span>
                <div className="resource-nav-text">
                  <span className="resource-nav-label">{item.label}</span>
                  <span className="resource-nav-description">{item.description}</span>
                </div>
              </div>
              {item.count !== undefined && item.count > 0 && (
                <span className={`resource-nav-count ${item.urgent ? 'urgent' : ''}`}>
                  {item.count}
                </span>
              )}
            </div>
          </button>
        ))}
      </nav>
    </div>
  );
};

export default ResourceSidebar;